import { ProjectListItem } from 'presentations/api/schema/project';
import { TeamUserListItem } from 'presentations/api/schema/team_user';
import { ViewerItem } from 'presentations/api/schema/user';
import { useEffect, useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import {
  defaultCacheExpiration,
  getPersistentItemWithViewer,
  setPersistentItemWithViewer,
} from 'presentations/views/helpers/storage';

type Props = {
  viewer: ViewerItem;
  selectedUsers: TeamUserListItem[];
  projects: ProjectListItem[];
  onClickAddMemberButton: () => void;
  onClickAddProjectButton: () => void;
};

export const selectedUserIdsKey = 'homeVisibleSettingSelectedUserIds';
export const selectedProjectIdsKey = 'homeVisibleSettingSelectedProjectIds';

export const useHomeVisibleSettingForm = (props: Props) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<TeamUserListItem[] | null>(
    null,
  );
  const [selectedProjects, setSelectedProjects] = useState<
    ProjectListItem[] | null
  >(null);

  useEffect(() => {
    if (selectedUsers == null && props.selectedUsers.length > 0) {
      const selectedUserIds = getPersistentItemWithViewer(
        selectedUserIdsKey,
        props.viewer,
      );
      if (Array.isArray(selectedUserIds)) {
        const users = [] as TeamUserListItem[];
        selectedUserIds.forEach((id) => {
          const user = props.selectedUsers.find((e) => e.id === id);
          if (user) {
            users.push(user);
          }
        });
        setSelectedUsers(users);
      } else {
        setSelectedUsers(props.selectedUsers);
      }
    }
  }, [selectedUsers, props.selectedUsers, isOpen]);

  useEffect(() => {
    if (selectedProjects == null && props.projects.length > 0) {
      const selectedProjectIds = getPersistentItemWithViewer(
        selectedProjectIdsKey,
        props.viewer,
      );
      if (Array.isArray(selectedProjectIds)) {
        const projects = [] as ProjectListItem[];
        selectedProjectIds.forEach((id) => {
          const project = props.projects.find((e) => e.id === id);
          if (project) {
            projects.push(project);
          }
        });
        setSelectedProjects(projects);
      } else {
        setSelectedProjects(props.projects);
      }
    }
  }, [selectedProjects, props.projects, isOpen]);

  useEffect(() => {
    if (isOpen) {
      setSelectedUsers(null);
      setSelectedProjects(null);
    }
  }, [isOpen]);

  const onCancel = () => {
    setOpen(false);
  };

  const onClickAddMemberButton = () => {
    setOpen(false);
    props.onClickAddMemberButton();
  };

  const onClickAddProjectButton = () => {
    setOpen(false);
    props.onClickAddProjectButton();
  };

  return {
    state: {
      isLoading: false,
      isOpen,
      viewer: props.viewer,
    },
    actions: {
      setOpen,
      onCancel,
      onClickAddMemberButton,
      onClickAddProjectButton,
    },
  };
};
